export const BRAND = {
  name: "Evo Technology",
  short: "Evo",
  tagline: "Engineering Greater Possibilities",
  email: "hr@evotechnology.org",
  address: "9 Butler Road, Dalibagh, Near Ganna Sansthan, Hazratganj 226010",
  founded: "2017",
  social: {
    linkedin: "#",
    twitter: "#",
    github: "#",
    dribbble: "#",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    id: "custom-software",
    number: "01",
    title: "Custom Software Development",
    short: "Bespoke platforms engineered to fit your operations.",
    description:
      "From enterprise-grade SaaS to mission-critical internal tooling, we architect resilient systems with thoughtful APIs, clean domain models and a craftsperson's obsession for detail.",
    deliverables: [
      "Discovery & architecture sprints",
      "Full-stack engineering teams",
      "Long-term maintenance partnerships",
    ],
  },
  {
    id: "web-mobile",
    number: "02",
    title: "Web & Mobile Applications",
    short: "Pixel-perfect experiences across every screen.",
    description:
      "React, Next.js, React Native and Swift — we ship product-grade web and mobile applications that feel premium, scale gracefully and convert visitors into customers.",
    deliverables: [
      "Web platforms & marketing sites",
      "iOS & Android native apps",
      "Progressive web applications",
    ],
  },
  {
    id: "cloud-devops",
    number: "03",
    title: "Cloud & DevOps",
    short: "Infrastructure that scales while you sleep.",
    description:
      "AWS, GCP and Azure architecture, Kubernetes orchestration, GitOps pipelines and FinOps cost-tuning — handed off with documentation your CTO will actually read.",
    deliverables: [
      "Multi-cloud architecture",
      "CI/CD & automated delivery",
      "Observability & cost optimization",
    ],
  },
  {
    id: "ai-ml",
    number: "04",
    title: "AI / ML & Data Engineering",
    short: "Models that earn their keep.",
    description:
      "Retrieval-augmented LLMs, recommendation systems, computer vision and the boring-but-essential data pipelines that make any of it possible.",
    deliverables: [
      "LLM applications & RAG systems",
      "Predictive ML & forecasting",
      "Data lakehouses & ELT pipelines",
    ],
  },
  {
    id: "design",
    number: "05",
    title: "UI / UX Design",
    short: "Interfaces that feel inevitable.",
    description:
      "Research-led product design and brand systems — wireframes, prototypes, design tokens and motion specs delivered alongside production-ready Figma files.",
    deliverables: [
      "Product & UX research",
      "Design systems & components",
      "Motion design & prototyping",
    ],
  },
  {
    id: "security",
    number: "06",
    title: "IT Consulting & Cybersecurity",
    short: "Strategy and defense, in equal measure.",
    description:
      "Threat modeling, penetration testing, SOC 2 readiness and fractional CTO engagements for teams scaling past the awkward middle.",
    deliverables: [
      "Security audits & pen-testing",
      "Compliance (SOC 2, ISO 27001)",
      "Fractional CTO & IT strategy",
    ],
  },
];

export const STATS = [
  { value: "98%", label: "Client retention" },
  { value: "150+", label: "Products shipped" },
  { value: "42", label: "Engineers worldwide" },
  { value: "11", label: "Industries served" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Discover",
    body: "We immerse in your business, audit existing systems, interview stakeholders and define crisp success metrics.",
  },
  {
    step: "02",
    title: "Design",
    body: "Architecture, UX flows and a delivery roadmap — costed, scoped and signed before a single line of production code.",
  },
  {
    step: "03",
    title: "Develop",
    body: "Tight, two-week sprints. Demoable software every cycle. Senior engineers, never hand-offs to juniors.",
  },
  {
    step: "04",
    title: "Deploy & Evolve",
    body: "We launch, instrument, observe and iterate — staying with you long after the celebratory shipped-it dinner.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Evo rebuilt our checkout in six weeks and lifted conversion by 31%. Quiet confidence, deep expertise — the rarest combination.",
    author: "Lina Marchetti",
    role: "VP Engineering, Halcyon Retail",
  },
  {
    quote:
      "They behave like a senior in-house team that simply happens to have its own office. We've extended twice already.",
    author: "Daniel Okafor",
    role: "Founder, Verde Logistics",
  },
  {
    quote:
      "The most thoughtful design partner we've worked with in a decade. Every detail earned its place.",
    author: "Priya Anand",
    role: "Chief Product Officer, Nordhaus",
  },
];

export const VALUES = [
  {
    title: "Craft over volume",
    body: "We staff fewer projects than we could, and we ship work we'd put our names on.",
  },
  {
    title: "Honest by default",
    body: "Estimates you can plan around. Trade-offs explained, not hidden in footnotes.",
  },
  {
    title: "Built to be inherited",
    body: "Clean code, written tests and documentation that survives long after we hand off.",
  },
  {
    title: "Long arc thinking",
    body: "Most of our clients have been with us five years or more. That's not an accident.",
  },
];

export const INDUSTRIES = [
  "Fintech",
  "Healthcare",
  "Logistics",
  "Retail & E-commerce",
  "Media & Publishing",
  "SaaS Platforms",
  "Real Estate",
  "Public Sector",
];

export const MEDIA = {
  hero: "https://images.unsplash.com/photo-1741356474365-5f0041f89eaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGdsb3dpbmclMjBnb2xkJTIwbGluZXMlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODI4MDY5NzB8MA&ixlib=rb-4.1.0&q=85",
  aboutOffice:
    "https://images.pexels.com/photos/36713443/pexels-photo-36713443.jpeg",
  serviceAbstract:
    "https://images.unsplash.com/photo-1781817957462-1b81e123c0c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdsb3dpbmclMjBnb2xkJTIwbGluZXMlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODI4MDY5NzB8MA&ixlib=rb-4.1.0&q=85",
  serviceServers:
    "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjByb29tJTIwZGFyayUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MjgwNjk2OXww&ixlib=rb-4.1.0&q=85",
  contactBg:
    "https://images.unsplash.com/photo-1480944657103-7fed22359e1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMGFyY2hpdGVjdHVyZSUyMG5pZ2h0fGVufDB8fHx8MTc4MjgwNjk3MHww&ixlib=rb-4.1.0&q=85",
  teamMeeting:
    "https://images.pexels.com/photos/8369249/pexels-photo-8369249.jpeg",
};
